import type { IStockRepository } from '@/features/stock/domain/repositories/IStockRepository.js';

interface Deps { stockRepository: IStockRepository; }

export interface RecalcWarehouseParams { orgId: string; projectId: string; warehouseId: string; }

export function createRecalcWarehouseUseCase({ stockRepository }: Deps) {
  return async function recalcWarehouse({ orgId, projectId, warehouseId }: RecalcWarehouseParams): Promise<void> {
    return stockRepository.recalcWarehouse(orgId, projectId, warehouseId);
  };
}
